//minimum width for fitting all components in nicely (nothing collapsed/hidden)
//homepage header has a bit more space since there is no search bar
export const MIN_WIDTH_DESKTOP = '66rem';
export const MIN_WIDTH_HOMEPAGE_DESKTOP = '75rem';
export const GA_CATEGORY = 'Header Menu';
